"use client"

// src/components/flip.ts
var Flip = {
  baseStyle: {
    container: {
      position: "relative",
      userSelect: "none",
      _disabled: {
        cursor: "not-allowed"
      },
      _readOnly: {
        cursor: "default"
      }
    },
    flipIdent: {
      backfaceVisibility: "hidden",
      position: "absolute",
      top: 0
    },
    from: {},
    to: {}
  },
  variants: {},
  sizes: {},
  defaultProps: {}
};

export {
  Flip
};
//# sourceMappingURL=chunk-CTH4WMF6.mjs.map